import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CloseIcon from '@mui/icons-material/Close';
import '../shared.css';

const BranchEdit = ({ match }) => {
  const recordId = match.params.id;
  const history  = useHistory();
  const { isAuthenticated, companyId, userId, logout, token } = useAuth();

  const [formData, setFormData] = useState({
    Name: '', BranchCode: '', ContactNumber1: '',
    Email: '', GSTNumber: '', CINNumber: '', AddressLine: '',
  });
  const [errorMessage,   setErrorMessage]   = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
  }, [isAuthenticated, companyId, userId, token, logout]);

  useEffect(() => {
    fetchData('BranchApi', `/BranchDetails/${recordId}`, token)
      .then(res => { if (res.responseCode === '1111') setFormData(res.response_data); })
      .catch(err => console.error('Error fetching Branch Details:', err));
  }, [recordId, token]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateData('BranchApi', `${recordId}`, { ...formData, UpdatedBy: userId }, token);
      setSuccessMessage('Branch updated successfully!');
      history.push('/branchIndex');
    } catch (err) {
      console.error('Error updating record:', err);
      setErrorMessage('Failed to update branch. Please try again.');
    }
  };

  return (
    <div className="pg-container">
      <form onSubmit={handleSubmit}>

        {/* Header */}
        <div className="pg-header">
          <h5 className="pg-title">Branch — Edit</h5>
          <div className="pg-header-actions">
            <button type="submit" className="pg-btn pg-btn-success">
              <DoneAllIcon /> Update
            </button>
            <Link to="/branchIndex" className="pg-btn pg-btn-danger">
              <CloseIcon /> Cancel
            </Link>
          </div>
        </div>

        {/* Alerts */}
        {errorMessage   && <div className="pg-alert pg-alert-error">{errorMessage}</div>}
        {successMessage && <div className="pg-alert pg-alert-success">{successMessage}</div>}

        <div className="pg-card">
          {/* Row 1 — Name + Code */}
          <div className="pg-form-grid pg-form-grid-2">
            <div className="pg-field">
              <label className="pg-label">Branch Name</label>
              <input className="pg-input" type="text" name="Name"
                placeholder="Enter branch name"
                value={formData.Name} onChange={handleChange}
                required maxLength={50} />
            </div>
            <div className="pg-field">
              <label className="pg-label">Branch Code</label>
              <input className="pg-input" type="text" name="BranchCode"
                placeholder="Enter branch code"
                value={formData.BranchCode} onChange={handleChange}
                maxLength={20} />
            </div>
          </div>

          {/* Row 2 — Contact / Email / GST / CIN */}
          <div className="pg-form-grid pg-form-grid-4">
            <div className="pg-field">
              <label className="pg-label">Contact Number</label>
              <input className="pg-input" type="text" name="ContactNumber1"
                placeholder="Enter contact number"
                value={formData.ContactNumber1} onChange={handleChange}
                required maxLength={15} />
            </div>
            <div className="pg-field">
              <label className="pg-label">Email</label>
              <input className="pg-input" type="email" name="Email"
                placeholder="Enter email"
                value={formData.Email} onChange={handleChange}
                maxLength={40} />
            </div>
            <div className="pg-field">
              <label className="pg-label">GST Number</label>
              <input className="pg-input" type="text" name="GSTNumber"
                placeholder="Enter GST number"
                value={formData.GSTNumber} onChange={handleChange}
                maxLength={15} />
            </div>
            <div className="pg-field">
              <label className="pg-label">CIN Number</label>
              <input className="pg-input" type="text" name="CINNumber"
                placeholder="Enter CIN number"
                value={formData.CINNumber} onChange={handleChange}
                maxLength={30} />
            </div>
          </div>

          {/* Row 3 — Address */}
          <div className="pg-form-grid pg-form-grid-1">
            <div className="pg-field">
              <label className="pg-label">Address Line</label>
              <input className="pg-input" type="text" name="AddressLine"
                placeholder="Enter address"
                value={formData.AddressLine} onChange={handleChange}
                maxLength={200} />
            </div>
          </div>
        </div>

      </form>

      <div className="pg-watermark">
        <CopyrightIcon style={{ fontSize: 12 }} />
        <b>EFFTABS SOLUTIONS LLP</b>
      </div>
    </div>
  );
};

export default BranchEdit;
